import { useMutation, useQueryClient } from '@tanstack/react-query';
import { recallReportService } from '@/services';
import { queryKeys } from '@/services/query-keys';
import { RecallReportListItem } from '@/types';
import { logger } from '@/utils/logger';

interface SendPayload {
  reportId: number;
}

type SendOptions = {
  onSuccess?: (data: RecallReportListItem) => void;
  onError?: (error: Error) => void;
};

export const useSendRecallReport = (options?: SendOptions) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ reportId }: SendPayload) =>
      recallReportService.sendReport(reportId),
    onSuccess: async (data, { reportId }) => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.recallReport.detail(reportId) });
      await queryClient.invalidateQueries({ queryKey: queryKeys.recallReport.list() });
      options?.onSuccess?.(data);
    },
    onError: (error: Error) => {
      logger.error('Failed to send recall report:', error);
      options?.onError?.(error);
    },
  });
};
